import { render, staticRenderFns } from "./BookingsExpired.vue?vue&type=template&id=ca82c026&"
import script from "./BookingsExpired.vue?vue&type=script&lang=js&"
export * from "./BookingsExpired.vue?vue&type=script&lang=js&"
import style0 from "./BookingsExpired.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports